module.exports = __webpack_public_path__ + "img/slide13.855a3227.png";